import React from 'react';
import GqlQueryWrapper from '../../components/GqlQueryWrapper/GqlQueryWrapper';
import SummaryPreRender from '../../components/Summary/Summary.prerender';
import { TRANSPARENCY_TYPES } from '../../utils/constants';

import { ALL_HOLDINGS_DATE } from './queries';
import AllHoldingsCard from './AllHoldings.card';
import { calculateMostRecentEndOfMonth } from './compliantDateUtils';

export const allHoldingsWrapperUtil = (gqlResult) => {
    if (!gqlResult) return null;

    const {
        fullHoldings: { asOfDate },
        transparencyTypeName
    } = gqlResult.exchangeTradedFund ||
        gqlResult.mutualFund || { fullHoldings: {} };

    const firstAvailableDateRaw =
        transparencyTypeName === TRANSPARENCY_TYPES.FULL
            ? asOfDate || new Date().toISOString() // defend against split being called on null for daily holdings
            : calculateMostRecentEndOfMonth(asOfDate);

    return {
        firstAvailableDate: firstAvailableDateRaw.split('T')[0]
    };
};

const AllHoldingsCardWrapper = ({ ticker, etf }) => (
    <GqlQueryWrapper
        query={ALL_HOLDINGS_DATE(etf)}
        variables={{ ticker }}
        dataFunc={allHoldingsWrapperUtil}
        placeholder={() => <SummaryPreRender />}
        unbatch
    >
        {({ data: { firstAvailableDate } }) => (
            <AllHoldingsCard
                ticker={ticker}
                etf={etf}
                firstAvailableDate={firstAvailableDate}
            />
        )}
    </GqlQueryWrapper>
);

export default AllHoldingsCardWrapper;
